<!-- 普通用户 申请 -->
<template>
  <div class="pager">
    <div class="common-user" v-if="!page.showResult">
      <div class="page-header">
        <ul class="current-steps">
          <li
            :class="['step', 'applyUser', { isActive: page.tabActived > -1 }]"
          >
            <div class="itemBox">
              <div class="tab-grid-item">
                <div class="tab-number circle">
                  {{ navList.applyUser.Id }}
                </div>
              </div>
              <div class="line"></div>
            </div>
            <div class="tab-title">
              {{ navList.applyUser.title }}
            </div>
          </li>
          <li
            :class="[
              'step',
              'respondentUser',
              { isActive: page.tabActived > 0 },
            ]"
          >
            <div class="itemBox">
              <div class="tab-grid-item">
                <div class="tab-number circle">
                  {{ navList.respondentUser.Id }}
                </div>
              </div>
              <div class="line"></div>
            </div>
            <div class="tab-title">
              {{ navList.respondentUser.title }}
            </div>
          </li>
          <li
            :class="[
              'step',
              'disputeContent',
              { isActive: page.tabActived > 1 },
            ]"
          >
            <div class="itemBox">
              <div class="tab-grid-item">
                <div class="tab-number circle">
                  {{ navList.disputeContent.Id }}
                </div>
              </div>
              <div class="line"></div>
            </div>
            <div class="tab-title">
              {{ navList.disputeContent.title }}
            </div>
          </li>
          <li
            :class="['step', 'organization', { isActive: page.tabActived > 2 }]"
          >
            <div class="itemBox">
              <div class="tab-grid-item">
                <div class="tab-number circle">
                  {{ navList.organization.Id }}
                </div>
              </div>
            </div>
            <div class="tab-title">
              {{ navList.organization.title }}
            </div>
          </li>
        </ul>
      </div>

      <van-form class="applyUser" v-show="navList.applyUser.isShow">
        <div class="tab-Content">
          <div class="form">
            <div class="applyUser">
              <h3 class="page-header-warming">
                <svg-icon iconClass="bulb" className="svg" />
                <span class="content"> {{ page.warmingContent }}</span>
              </h3>
              <div class="form-container">
                <div class="container applierUser">
                  <div class="model-container">
                    <h2 class="info-block">
                      <span class="info-block-title"> 申请人信息 </span>
                    </h2>
                  </div>
                  <div
                    class="applyUser-item"
                    v-for="applyUserItem in form.applyUserList"
                    :key="applyUserItem.userId"
                  >
                    <div class="field">
                      <div class="van-cell van-cell--required van-field">
                        <div class="van-cell__title van-field__label">
                          <span>申请人</span>
                        </div>
                        <van-radio-group
                          v-model="applyUserItem.userType"
                          direction="horizontal"
                        >
                          <van-radio name="JURIDICAL_PERSON">
                            <template #icon="props">
                              <svg-icon
                                :iconClass="
                                  props.checked
                                    ? 'radio'
                                    : 'radioButtonUnselect'
                                "
                                className="svg"
                              /> </template
                            >企业</van-radio
                          >
                          <van-radio name="NATURAL_PERSON">
                            <template #icon="props">
                              <svg-icon
                                :icon-class="
                                  props.checked
                                    ? 'radio'
                                    : 'radioButtonUnselect'
                                "
                                className="svg"
                              /> </template
                            >自然人</van-radio
                          >
                        </van-radio-group>
                      </div>
                    </div>
                    <div
                      v-if="applyUserItem.userType === 'JURIDICAL_PERSON'"
                      class="JURIDICAL_PERSON"
                    >
                      <div class="field">
                        <van-field
                          v-model="applyUserItem.companyName"
                          label="公司名称"
                          placeholder="请输入"
                          required
                          maxlength="50"
                          :rules="rules.companyName"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.corporation"
                          label="法人代表"
                          required
                          placeholder="请输入"
                          :rules="rules.corporation"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.corporationPhone"
                          required
                          type="tel"
                          label=" 代表人电话"
                          placeholder="请输入"
                          :rules="rules.corporationPhone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.userName"
                          label=" 联系人"
                          placeholder="请输入"
                          required
                          :rules="rules.userName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.phone"
                          required
                          type="tel"
                          label=" 联系人电话"
                          placeholder="请输入"
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          readonly
                          required
                          clickable
                          label="国家"
                          v-model="applyUserItem.countryName"
                          placeholder="请选择"
                          @click.stop="callCountryPicker(applyUserItem)"
                        />
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.detailAddress"
                          required
                          label="联系地址"
                          placeholder="请输入"
                          :rules="rules.detailAddress"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.email"
                          required
                          label="电子邮件"
                          placeholder="请输入"
                          :rules="rules.email"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.fax"
                          label="传真"
                          placeholder="请输入"
                          :rules="rules.fax"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.zipCode"
                          label="邮编"
                          placeholder="请输入"
                          :rules="rules.zipCode"
                        >
                        </van-field>
                      </div>
                    </div>
                    <div v-else class="NATURAL_PERSON">
                      <div class="field">
                        <van-field
                          v-model="applyUserItem.userName"
                          label=" 联系人"
                          placeholder="请输入"
                          required
                          :rules="rules.userName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.phone"
                          required
                          type="tel"
                          label=" 联系人电话"
                          placeholder="请输入"
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          readonly
                          required
                          clickable
                          label="国家"
                          v-model="applyUserItem.countryName"
                          placeholder="请选择"
                          @click.stop="callCountryPicker(applyUserItem)"
                        />
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.detailAddress"
                          required
                          label="联系地址"
                          placeholder="请输入"
                          :rules="rules.detailAddress"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.email"
                          required
                          label="电子邮件"
                          placeholder="请输入"
                          :rules="rules.email"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.fax"
                          label="传真"
                          placeholder="请输入"
                          :rules="rules.fax"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="applyUserItem.zipCode"
                          label="邮编"
                          placeholder="请输入"
                          :rules="rules.zipCode"
                        >
                        </van-field>
                      </div>
                    </div>
                    <div
                      class="button-block field"
                      v-show="applyUserItem.isShowAddAgentButton"
                    >
                      <span
                        class="add-Agent-button"
                        @click.prevent="
                          handleAddAgent(applyUserItem, 'applyUserList')
                        "
                      >
                        添加代理人
                      </span>
                    </div>

                    <div
                      class="agent container"
                      v-for="agent in applyUserItem.agentList"
                      :key="agent.index"
                    >
                      <div class="model-container">
                        <h2 class="info-block">
                          <span class="info-block-title">代理人信息 </span>
                        </h2>

                        <div
                          v-show="!applyUserItem.isShowAddAgentButton"
                          class="button-right"
                          @click.stop="handleDeleteAgent(applyUserItem, agent)"
                        >
                          <span class="title">
                            <svg-icon iconClass="garbage" className="svg" />
                            删除</span
                          >
                        </div>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.userName"
                          label="代理人"
                          placeholder="请输入"
                          required
                          :rules="rules.userName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.phone"
                          type="tel"
                          label="代理人电话 "
                          placeholder="请输入 "
                          required
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.detailAddress"
                          required
                          label="联系地址 "
                          placeholder="联系地址 "
                          :rules="rules.detailAddress"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.email"
                          required
                          label="电子邮件"
                          placeholder="电子邮件"
                          :rules="rules.email"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.fax"
                          label="传真"
                          placeholder="传真"
                          :rules="rules.fax"
                        >
                        </van-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="other container">
                  <div class="field">
                    <div class="van-cell van-field">
                      <div class="van-cell__title van-field__label">
                        <span>是否为共同申请</span>
                      </div>
                      <van-radio-group
                        v-model="form.isJointApplication"
                        direction="horizontal"
                      >
                        <van-radio :name="0">
                          <template #icon="props">
                            <svg-icon
                              :icon-class="
                                props.checked ? 'radio' : 'radioButtonUnselect'
                              "
                              className="svg"
                            /> </template
                          >否</van-radio
                        >
                      </van-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-control container">
              <van-button
                :disabled="isDisableApplyUser"
                @click="handleClickNext('applyUser')"
                native-type="button"
                block
                style="
                  background: linear-gradient(#3790ff, #376bff);
                  border-radius: 5rem;
                  color: #ffffff;
                "
                >{{ page.buttonControl.nextStep.title }}</van-button
              >
            </div>
          </div>
        </div>
      </van-form>

      <van-form class="respondentUser" v-show="navList.respondentUser.isShow">
        <div class="tab-Content">
          <div class="form">
            <div>
              <h3 class="page-header-warming">
                <svg-icon iconClass="bulb" className="svg" />
                <span class="content"> {{ page.warmingContent }}</span>
              </h3>
              <div class="form-container">
                <div class="container applierUser">
                  <div class="model-container">
                    <h2 class="info-block">
                      <span class="info-block-title"> 被申请人信息 </span>
                    </h2>
                  </div>
                  <div
                    class="applyUser-item"
                    v-for="respondentUserItem in form.respondentUserList"
                    :key="respondentUserItem.userId"
                  >
                    <div class="field">
                      <div class="van-cell van-cell--required van-field">
                        <div class="van-cell__title van-field__label">
                          <span>被申请人</span>
                        </div>
                        <van-radio-group
                          v-model="respondentUserItem.userType"
                          direction="horizontal"
                        >
                          <van-radio name="JURIDICAL_PERSON">
                            <template #icon="props">
                              <svg-icon
                                :iconClass="
                                  props.checked
                                    ? 'radio'
                                    : 'radioButtonUnselect'
                                "
                                className="svg"
                              />
                            </template>
                            企业</van-radio
                          >
                          <van-radio name="NATURAL_PERSON">
                            <template #icon="props">
                              <svg-icon
                                :iconClass="
                                  props.checked
                                    ? 'radio'
                                    : 'radioButtonUnselect'
                                "
                                className="svg"
                              />
                            </template>
                            自然人</van-radio
                          >
                        </van-radio-group>
                      </div>
                    </div>
                    <div
                      v-if="respondentUserItem.userType === 'JURIDICAL_PERSON'"
                      class="JURIDICAL_PERSON"
                    >
                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.companyName"
                          label="公司名称"
                          placeholder="请输入"
                          required
                          :rules="rules.companyName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.corporation"
                          label="法人代表"
                          required
                          placeholder="请输入"
                          :rules="rules.corporation"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.corporationPhone"
                          required
                          type="tel"
                          label=" 代表人电话"
                          placeholder="请输入"
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.userName"
                          label=" 联系人"
                          placeholder="请输入"
                          required
                          :rules="rules.userName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.phone"
                          required
                          type="tel"
                          label=" 联系人电话"
                          placeholder="请输入"
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          readonly
                          required
                          clickable
                          label="国家"
                          v-model="respondentUserItem.countryName"
                          placeholder="请选择"
                          @click.stop="callCountryPicker(respondentUserItem)"
                        />
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.detailAddress"
                          required
                          label="联系地址"
                          placeholder="请输入"
                          :rules="rules.detailAddress"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.email"
                          required
                          label="电子邮件"
                          placeholder="请输入"
                          :rules="rules.email"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.fax"
                          label="传真"
                          placeholder="请输入"
                          :rules="rules.fax"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.zipCode"
                          label="邮编"
                          placeholder="请输入"
                          :rules="rules.zipCode"
                        >
                        </van-field>
                      </div>
                    </div>
                    <div v-else class="NATURAL_PERSON">
                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.userName"
                          label=" 联系人"
                          placeholder="请输入"
                          required
                          :rules="rules.userName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.phone"
                          required
                          type="tel"
                          label=" 联系人电话"
                          placeholder="请输入"
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          readonly
                          required
                          clickable
                          label="国家"
                          :value="respondentUserItem.countryName"
                          placeholder="请选择"
                          @click.stop="callCountryPicker(respondentUserItem)"
                          :rules="rules.countryName"
                        />
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.detailAddress"
                          required
                          label="联系地址"
                          placeholder="请输入"
                          :rules="rules.detailAddress"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.email"
                          required
                          label="电子邮件"
                          placeholder="请输入"
                          :rules="rules.email"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.fax"
                          label="传真"
                          placeholder="请输入"
                          :rules="rules.fax"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="respondentUserItem.zipCode"
                          label="邮编"
                          placeholder="请输入"
                          :rules="rules.zipCode"
                        >
                        </van-field>
                      </div>
                    </div>
                    <div
                      class="button-block"
                      v-show="respondentUserItem.isShowAddAgentButton"
                    >
                      <span
                        class="add-Agent-button"
                        @click.prevent="
                          handleAddAgent(
                            respondentUserItem,
                            'respondentUserList'
                          )
                        "
                      >
                        添加代理人
                      </span>
                    </div>

                    <div
                      class="agent container"
                      v-for="agent in respondentUserItem.agentList"
                      :key="agent.id"
                    >
                      <div class="model-container">
                        <h2 class="info-block">
                          <span class="info-block-title">代理人信息 </span>
                        </h2>

                        <div
                          v-show="!respondentUserItem.isShowAddAgentButton"
                          class="button-right"
                          @click.stop="
                            handleDeleteAgent(respondentUserItem, agent)
                          "
                        >
                          <span class="title"
                            ><svg-icon
                              iconClass="garbage"
                              className="svg"
                            />删除</span
                          >
                        </div>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.userName"
                          label="代理人"
                          placeholder="请输入"
                          required
                          :rules="rules.userName"
                          maxlength="50"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.phone"
                          label="代理人电话 "
                          type="tel"
                          placeholder="请输入 "
                          required
                          :maxlength="11"
                          :rules="rules.phone"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.detailAddress"
                          required
                          label="联系地址 "
                          placeholder="联系地址 "
                          :rules="rules.detailAddress"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.email"
                          required
                          label="电子邮件"
                          placeholder="电子邮件"
                          :rules="rules.email"
                        >
                        </van-field>
                      </div>

                      <div class="field">
                        <van-field
                          v-model="agent.fax"
                          label="传真"
                          placeholder="传真"
                          :rules="rules.fax"
                        >
                        </van-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-control container">
              <van-button
                native-type="button"
                @click="handleClickPrevious('respondentUser')"
                class="Previous-button"
                style="
                  background: #ecf1ff;
                  border-radius: 5rem;
                  padding: 0.5rem 1rem;
                  color: #376bff;
                  margin: auto 0.5rem;
                "
                >{{ page.buttonControl.previousStep.title }}</van-button
              >
              <van-button
                :disabled="isDisableRespondentUser"
                native-type="button"
                @click="handleClickNext('respondentUser')"
                style="
                  background: linear-gradient(#3790ff, #376bff);
                  border-radius: 5rem;
                  padding: 0.5rem 1rem;
                  color: #ffffff;
                  margin: auto 0.5reml;
                "
                >{{ page.buttonControl.nextStep.title }}</van-button
              >
            </div>
          </div>
        </div>
      </van-form>

      <van-form class="disputeContent" v-show="navList.disputeContent.isShow">
        <div class="tab-Content">
          <div class="tab-Content">
            <div class="form">
              <div class="disputeContent">
                <div class="form-container">
                  <div class="container disputeContent">
                    <div class="model-container">
                      <h2 class="info-block">
                        <span class="info-block-title"> 填写争议内容 </span>
                      </h2>
                    </div>
                    <div class="field field2">
                      <div class="textarea">
                        <label class="required fieldTitle">基本事实 </label>
                        <van-field
                          v-model="form.appeal"
                          placeholder="请描述"
                          rows="5"
                          type="textarea"
                        />
                      </div>
                    </div>
                    <div class="field field2">
                      <div class="textarea">
                        <label class="required fieldTitle"> 争议要点</label>
                        <van-field
                          v-model="form.disputeContent"
                          placeholder="请描述"
                          rows="5"
                          type="textarea"
                        />
                      </div>
                    </div>
                    <div class="field field2">
                      <div class="textarea">
                        <label class="required fieldTitle"> 调解请求</label>
                        <van-field
                          v-model="form.mediationRequest"
                          placeholder="请描述"
                          rows="5"
                          type="textarea"
                        />
                      </div>
                    </div>
                    <div class="field field2 money">
                      <van-field
                        v-model="form.amount"
                        type="digit"
                        label="争议金额"
                        required
                        autosize
                        placeholder="请输入"
                        @input="handleChangeAmount"
                      >
                        <template #extra>
                          <div class="rem">RMB</div>
                        </template>
                      </van-field>
                    </div>
                    <div class="field money field2">
                      <van-field
                        v-model="form.manageFee"
                        type="digit"
                        label="预估管理费"
                        readonly
                        placeholder="自动获取"
                      >
                        <template #extra>
                          <div class="rem">RMB</div>
                        </template>
                      </van-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="button-control container">
            <van-button
              native-type="button"
              @click="handleClickPrevious('disputeContent')"
              class="Previous-button"
              style="
                background: #ecf1ff;
                border-radius: 5rem;
                padding: 0.5rem 1rem;
                color: #376bff;
                margin: auto 0.5rem;
              "
              >{{ page.buttonControl.previousStep.title }}</van-button
            >
            <van-button
              :disabled="isDisableDisputeContentTab"
              native-type="button"
              @click="handleClickNext('disputeContent')"
              style="
                background: linear-gradient(#3790ff, #376bff);
                border-radius: 5rem;
                padding: 0.5rem 1rem;
                color: #ffffff;
                margin: auto 0.5reml;
              "
              >{{ page.buttonControl.nextStep.title }}</van-button
            >
          </div>
        </div>
      </van-form>
      <van-form class="organization" v-show="navList.organization.isShow">
        <div class="tab-Content">
          <div class="form">
            <div class="form-container">
              <div class="container form-organization">
                <div class="model-container">
                  <h2 class="info-block">
                    <span class="info-block-title"> 选择调解机构 </span>
                  </h2>
                </div>
                <van-search
                  shape="round"
                  v-model="page.search"
                  placeholder="请输入您查找的调解中心"
                  @input="handleSearchOrganizationList"
                  background="#F5F5F5"
                  right-icon="search"
                  left-icon=""
                  autofocus
                />
                <van-empty
                  v-if="Pagination.total === 0"
                  description="暂无数据"
                />
                <van-list
                  v-model="page.isLoading"
                  :finished="isNoMoreOrganizations"
                  finished-text="没有更多了"
                  @load="handlePageChange"
                >
                  <div
                    class="org-item"
                    v-for="organizationItem in page.organizationList"
                    :key="organizationItem.organization.id"
                  >
                    <div
                      class="organization-Item"
                      @click="handleChooseOrganization(organizationItem)"
                      :class="{
                        'organization-Item-isChosen':
                          form.orgId === organizationItem.organization.id,
                      }"
                    >
                      <div class="name row">
                        <h3 class="organization-name">
                          {{ organizationItem.organization.name }}
                        </h3>
                        <div
                          class="mediator-num"
                          :class="{
                            'mediator-num-isChosen':
                              form.orgId === organizationItem.organization.id,
                          }"
                        >
                          {{ organizationItem.mediatorNum }}名调解员
                        </div>
                      </div>
                      <div class="address row">
                        <svg-icon iconClass="address" className="svg" />

                        {{ organizationItem.organization.address }}
                      </div>
                      <div class="contactPhone row">
                        <svg-icon iconClass="phone" className="svg" />
                        {{ organizationItem.organization.seatPhone }}
                      </div>
                    </div>
                  </div>
                </van-list>
                <div
                  class="button-control container"
                  style="background: #f5f5f5"
                >
                  <van-button
                    native-type="button"
                    @click="handleClickPrevious('organization')"
                    class="Previous-button"
                    style="
                      background: #ecf1ff;
                      border-radius: 5rem;
                      padding: 0.5rem 1rem;
                      color: #376bff;
                      margin: auto 0.5rem;
                    "
                    >{{ page.buttonControl.previousStep.title }}</van-button
                  >
                  <van-button
                    :disabled="isDisableSubmitForm"
                    native-type="button"
                    @click="handleClickSubmit"
                    style="
                      background: linear-gradient(#3790ff, #376bff);
                      border-radius: 5rem;
                      padding: 0.5rem 1rem;
                      color: #ffffff;
                      margin: auto 0.5reml;
                    "
                    >{{ page.buttonControl.submit.title }}</van-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-form>

      <countryPicker @setCountryPicker="setCountryPicker" ref="countryPicker" />
    </div>
    <div class="result-container" v-else>
      <div>
        <h1>
          <img src="../../assets/img/addCase-result.png" class="image" />
        </h1>
        <h1 class="message">提交成功</h1>
        <p class="info">
          <span>您的调解申请已成功提交，请登录PC端官网上传证据材料</span>
          <span>官网地址：https://adr.ccpit.org/</span>
        </p>
        <div class="return-btn" style="display: flex;
    justify-content: center;">
          <van-button
            native-type="button"
            round
            block
            type="info"
            style="
              background: linear-gradient(#3790ff, #376bff);
              border-radius: 5rem;
              color: #ffffff;
              padding: 0.5rem 1.5rem;
              width:60%;
            "
            @click.stop="handleGotoMyCase"
            >返回</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getDictByType, getOrganizationList } from "@/api/common.js";
import { addCase } from "@/api/application";

import { getStore } from "@/utils/utils";

import countryPicker from "./components/country.vue";
export default {
  name: "application",
  components: { countryPicker },
  data() {
    //这里存放数据
    const isEmail = (val) => {
      const pattern =
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      return pattern.test(val);
    };
    const isMObile = (val) => {
      const pattern =
        /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/;
      return pattern.test(val);
    };
    return {
      userInfo: {},
      page: {
        isLoading: false,
        curTabId: "applyUser",
        showResult: false,
        currentUserItem: null,
        search: "",
        organizationList: [],
        warmingContent: "若需共同申请调解请移步PC端官网提交申请",
        countryList: [],
        default: { countryIndex: -1 },
        isBusy: false,
        tabActived: "",
        buttonControl: {
          previousStep: {
            title: "上一步",
            isShow: false,
            Step: "",
          },
          nextStep: {
            title: "下一步",
            isShow: false,
            Step: "",
          },
          submit: {
            title: "提  交",
            isShow: false,
            Step: null,
          },
        },
      },
      rules: {
        userName: [{ required: true, message: "必填" }],
        required: [{ required: true, message: "必填" }],
        companyName: [{ required: true, message: "必填" }],
        corporation: [{ required: true, message: "必填" }],
        corporationPhone: [
          { validator: isMObile, required: true, message: "请输入正确内容" },
        ],
        phone: [
          { validator: isMObile, required: true, message: "请输入正确内容" },
        ],
        countryName: [{ required: true, message: "必填" }],
        detailAddress: [{ required: true, message: "必填" }],
        email: [{ validator: isEmail, message: "请输入正确内容" }],
        fax: [],
        zipCode: [],
        isJointApplication: [],
        zipCode: [{ pattern: /[1-9]\d{5}(?!\d)/, message: "请输入正确内容" }], //邮编
      },
      Pagination: {
        total: 0,
        pageNum: 0,
        pageSize: 5,
        size: 5,
        startRow: 1,
        endRow: 5,
        pages: 0,
        prePage: 0,
        nextPage: 0,
        isFirstPage: true,
        isLastPage: false,
        hasPreviousPage: false,
        hasNextPage: true,
        navigatePages: 0,
        navigatepageNums: [],
        navigateFirstPage: 0,
        navigateLastPage: 0,
        firstPage: 0,
        lastPage: 0,
      },
      form: {
        isJointApplication: 0,
        disputeContent: "",
        amount: null,
        applyUserList: [],
        orgName: "",
        respondentUserList: [],
        mediationRequest: "",
        isDraft: 0,
        appeal: "",
        orgId: 0,
        editCase: false,
        orgAreaCode: "",
        id: 0,
        fileList: [],
      },
      navList: {
        applyUser: {
          Id: 1,
          name: "applyUser",
          title: "申请人",
          previous: null,
          next: "respondentUser",
          isValidated: false,
          isShow: true,
        },
        respondentUser: {
          Id: 2,
          name: "respondentUser",
          title: "被申请人",
          previous: "applyUser",
          next: "disputeContent",
          isValidated: false,
          isShow: false,
        },
        disputeContent: {
          Id: 3,
          name: "disputeContent",
          title: "争议内容",
          previous: "respondentUser",
          next: "organization",
          isValidated: false,
          isShow: false,
        },
        organization: {
          Id: 4,
          name: "organization",
          title: "选择机构",
          previous: "disputeContent",
          next: null,
          isValidated: false,
          isShow: false,
        },
        result: {
          Id: 5,
          name: "result",
          title: "结构",
          previous: "organization",
          next: null,
        },
      },
    };
  },
  computed: {
    isNoMoreOrganizations() {
      return this.Pagination.total <= this.Pagination.endRow;
    },
    isDisableApplyUser() {
      return !this.navList.applyUser.isValidated;
    },
    isDisableRespondentUser() {
      return !this.navList.respondentUser.isValidated;
    },
    isDisableDisputeContentTab() {
      return !this.navList.disputeContent.isValidated;
    },
    isDisableOrganization() {
      return !this.navList.organization.isValidated;
    },
    isDisableSubmitForm() {
      return (
        this.isDisableApplyUser ||
        this.isDisableRespondentUser ||
        this.isDisableDisputeContentTab ||
        this.isDisableOrganization
      );
    },
  },
  //方法集合
  methods: {
    // common
    handleControlcountryPop(current) {
      current.showCountryPicker = !current.showCountryPicker;
    },
    callCountryPicker(current) {
      this.page.currentUserItem = current;
      this.$refs["countryPicker"].handlePop();
    },
    setCountryPicker(country) {
      this.page.currentUserItem.countryName = country.name;
    },
    fillCountryListData() {
      getDictByType({
        //数据类型(country：国籍；nation：民族；identification_type：证件类型：qualifications：学历；degree：学位；politics：政治面貌)
        type: "country",
      }).then((res) => {
        const list = res.data;
        this.page.countryList.push(...list);
        this.setDefaultCountry();
      });
    },
    setDefaultCountry() {
      this.page.default.countryIndex = this.page.countryList.findIndex(
        (ele) => ele.name === "中国"
      );
    },
    handleConfirmCountry(current, value) {
      current.countryName = value.name;
      current.showCountryPicker = false;
    },
    handleClickPrevious(stepName) {
      // 获取当前tab 的下一页面
      const currentTab = this.navList[stepName];
      this.setCurrentStep(currentTab.previous);
    },
    handleClickNext(stepName) {
      // 验证当前tab中的form
      // 获取当前tab 的下一页面
      console.log("stepName :>> ", stepName);
      const currentTab = this.navList[stepName];
      this.setCurrentStep(currentTab.next);
    },
    handleClickSubmit() {
      const req = {
        ...this.form,
      };
      addCase(req).then((res) => {
        if (res.data.code === 200) {
          this.$toast.success(res.data.message);
          //  const  {data} = res.data.result // caseId
          this.page.showResult = true;
        } else {
          this.$toast.fail("提交失败，请重试" + res.data.message);
        }
      });
    },
    setCurrentStep(argName) {
      // Id: 2,
      //     name: "respondentUser",
      //     title: "被申请人",
      //     previous: "applyUser",
      //     next: "disputeContent",
      //     isValidated: false,
      //     isShow: false,
      // 根据传入的名称，设置nav的效果
      const keys = Object.keys(this.navList);
      keys.forEach((item) => {
        if (this.navList[item].name !== argName) {
          this.navList[item].isShow = false;
        } else {
          this.navList[item].isShow = true;
          this.page.tabActived = this.navList[item].Id - 1;
        }
      });
    },
    // applyUser
    /** @description 添加不同角色下的代理人
     * currentUser: 当前选择的角色人信息
     * role: [applyUserList,respondentUserList]
     */
    handleAddAgent(currentUser, role = "applyUserList") {
      if (["applyUserList", "respondentUserList"].includes(role)) {
        let caseUserType = "";
        role == "applyUserList"
          ? (caseUserType = "APPLICANT_AGENT")
          : (caseUserType = "RESPONDENT");
        const agent = {
          index: currentUser.agentList.length,
          caseUserType: caseUserType, //用户身份APPLICANT("申请人"),RESPONDENT
          userType: "NATURAL_PERSON",
          userName: "", //联系人名称
          phone: "", //手机号
          email: "", //电子邮件
          fax: "", //传真
          detailAddress: "", //详细地址
          fileList: [],
        };
        currentUser.agentList.push(agent);
        currentUser.isShowAddAgentButton = false;
      }
    },
    /**
     * @description 添加香瓜角色下的用户信息对象
     * role: [applyUserList,respondentUserList]
     */
    addUser(role = "applyUserList") {
      if (["applyUserList", "respondentUserList"].includes(role)) {
        const temp = {
          caseUserType: "", //role === "applyUserList" ? "APPLICANT" : "RESPONDENT", //用户身份APPLICANT("申请人"),RESPONDENT("被申请人"),
          userType: "JURIDICAL_PERSON", //用户类型NATURAL_PERSON("自然人"),JURIDICAL_PERSON("法人"),UNINCORPORATED_ORGANIZATION("非法人组织");
          userName: "", //联系人名称
          companyName: "", //公司名称
          zipCode: "", //邮编
          wechatCode: "", //微信号
          sex: "", //性别
          phone: "", //手机号
          corporationPhone: "",
          email: "", //电子邮件
          fax: "", //传真
          country: {
            id: null,
            name: "",
            type: "",
          },
          countryName: "中国", //国家、地区名称
          countryCode: 180, //国家、地区code
          detailAddress: "", //详细地址
          creditCode: "", //信用码
          corporation: "", //法定代表人
          fileList: [],
          agentList: [],
          showCountryPicker: false, //页面用来判断国家弹框的辅助字段,
          isShowAddAgentButton: true, //页面辅助字段,
        };
        switch (role) {
          case "applyUserList": {
            temp.caseUserType = "APPLICANT"; //用户身份APPLICANT("申请人"),RESPONDENT("被申请人"),
            // temp.email = this.userInfo.email
            // temp.phone = this.userInfo.phone
            // temp.userName = this.userInfo.userName
            // temp.sex = this.userInfo.userDetailMap.sex === 'M'? '男':'女'
            temp.email = this.userInfo.user.email || "";
            temp.userName = this.userInfo.user.userName || "";
            temp.phone = this.userInfo.user.phone || "";
            temp.countryCode =
              (this.userInfo.userDetailMap.country &&
                this.userInfo.userDetailMap.country.id) ||
              180;
            temp.detailAddress =
              this.userInfo.userDetailMap.familyAddress || "";
            temp.fax = this.userInfo.userDetailMap.fax || "";
            temp.zipCode = this.userInfo.userDetailMap.postcode || "";
            temp.countryName =
              (this.userInfo.userDetailMap.country &&
                this.userInfo.userDetailMap.country.name) ||
              "中国";
            break;
          }
          case "respondentUserList": {
            temp.caseUserType = "RESPONDENT";
            break;
          }
          default:
            break;
        }
        this.form[role].push(temp);
        return temp;
      }
    },
    handleDeleteAgent(currentApplyUser, agentItem) {
      const index = currentApplyUser.agentList.findIndex(
        (ele) => ele.id === agentItem.id
      );
      if (index !== -1) {
        currentApplyUser.agentList.splice(index, 1);
      }
      if (currentApplyUser.agentList.length === 0) {
        currentApplyUser.isShowAddAgentButton = true;
      }
    },
    // 争议内容
    handleChangeAmount() {
      if (this.form.amount === "" || this.form.amount == null) {
        this.form.manageFee = null;
      } else if (this.form.amount < 1) {
        this.form.manageFee = 0;
      } else if (this.form.amount <= 50000) {
        this.form.manageFee = 1500;
      } else if (this.form.amount <= 100000) {
        this.form.manageFee = 2000;
      } else if (this.form.amount <= 200000) {
        this.form.manageFee = 3000;
      } else if (this.form.amount <= 500000) {
        this.form.manageFee = 5000;
      } else if (this.form.amount <= 1000000) {
        this.form.manageFee = 7000;
      } else if (this.form.amount <= 2000000) {
        this.form.manageFee = 9000;
      } else if (this.form.amount <= 5000000) {
        this.form.manageFee = 13000;
      } else if (this.form.amount <= 10000000) {
        this.form.manageFee = 16000;
      } else if (this.form.amount <= 20000000) {
        this.form.manageFee = 20000;
      } else if (this.form.amount <= 50000000) {
        this.form.manageFee = 30000;
      } else {
        this.form.manageFee = 40000;
      }
    },
    // 获取更多机构信息
    handlePageChange() {
      this.Pagination.pageNum++;
      this.searchOrganizationList();
    },
    // 获取机构列表
    searchOrganizationList() {
      const req = {
        pageNum: this.Pagination.pageNum,
        pageSize: this.Pagination.pageSize,
        areaCode: "",
        key: this.page.search,
      };
      this.page.isLoading = true;
      getOrganizationList(req).then((res) => {
        const { total, list, endRow, hasNextPage } = res.data.result;
        this.page.organizationList.push(...list);
        this.Pagination.total = total;
        this.Pagination.endRow = endRow;
        this.Pagination.hasNextPage = hasNextPage;
        this.page.isLoading = false;
      });
    },
    // 用户自主搜索机构
    handleSearchOrganizationList() {
      this.Pagination.pageNum = 1;
      this.page.organizationList = [];
      this.searchOrganizationList();
    },
    handleChooseOrganization(item) {
      this.form.orgId = item.organization.id;
      this.form.orgName = item.organization.name;
      this.form.orgAreaCode = item.organization.areaCode;
    },

    // 结果
    handleGotoMyCase() {
      this.$router.push({ name: "personalCenter" });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.userInfo = JSON.parse(getStore("userInfo")) || {};
    this.fillCountryListData();
    const arr = ["applyUserList", "respondentUserList"];
    arr.forEach((ele) => {
      const current = this.addUser(ele);
      // this.handleAddAgent(current);
    });
    this.handlePageChange();
    this.setCurrentStep("applyUser");
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  watch: {
    form: {
      handler: function (val) {
        // applyUser
        const applyUserNum = val["applyUserList"].length;
        for (let i = 0; i < applyUserNum; i++) {
          const item = val["applyUserList"][i];
          this.navList.applyUser.isValidated = true;
          if (item.userType === "JURIDICAL_PERSON") {
            if (item.companyName === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
            if (item.corporation === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
            if (item.corporationPhone === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
          }
          if (item.countryName === "") {
            this.navList.applyUser.isValidated = false;
            break;
          }
          if (item.userName === "") {
            this.navList.applyUser.isValidated = false;
            break;
          }

          if (item.phone === "") {
            this.navList.applyUser.isValidated = false;
            break;
          }

          if (item.detailAddress === "") {
            this.navList.applyUser.isValidated = false;
            break;
          }
          const agentrNum = item.agentList.length;
          for (let j = 0; j < agentrNum; j++) {
            const agentItem = item.agentList[j];
            if (agentItem.phone === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
            if (agentItem.userName === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
            if (agentItem.email === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
            if (agentItem.detailAddress === "") {
              this.navList.applyUser.isValidated = false;
              break;
            }
          }
        }
        //respondentUser
        const respondentUserNum = val["respondentUserList"].length;
        for (let index = 0; index < respondentUserNum; index++) {
          const item = val["respondentUserList"][index];
          this.navList.respondentUser.isValidated = true;

          if (item.userType === "JURIDICAL_PERSON") {
            if (item.companyName === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
            if (item.corporation === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
            if (item.corporationPhone === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
          }

          if (item.userName === "") {
            this.navList.respondentUser.isValidated = false;
            break;
          }

          if (item.phone === "") {
            this.navList.respondentUser.isValidated = false;
            break;
          }
          if (item.countryName === "") {
            this.navList.respondentUser.isValidated = false;
            break;
          }
          if (item.detailAddress === "") {
            this.navList.respondentUser.isValidated = false;
            break;
          }
          const agentrNum = item.agentList.length;
          for (let rj = 0; rj < agentrNum; rj++) {
            const agentItem = item.agentList[rj];
            if (agentItem.phone === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
            if (agentItem.userName === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
            if (agentItem.email === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
            if (agentItem.detailAddress === "") {
              this.navList.respondentUser.isValidated = false;
              break;
            }
          }
        }
        //disputeContent
        this.navList.disputeContent.isValidated = true;
        if (val.appeal === "") {
          this.navList.disputeContent.isValidated = false;
        }
        if (val.disputeContent === "") {
          this.navList.disputeContent.isValidated = false;
        }
        if (val.mediationRequest === "") {
          this.navList.disputeContent.isValidated = false;
        }
        if (!val.amount) {
          this.navList.disputeContent.isValidated = false;
        }
        // organization
        this.navList.organization.isValidated = true;
        if (val.orgName === "") {
          this.navList.organization.isValidated = false;
        }
      },
      immediate: true,
      deep: true, //对象的深度验证
    },
  },
};
</script>
<style lang='scss'>
//@import url(); 引入公共css类
.result-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 25% 10%;

  .image {
    width: 50%;
  }
  .message {
    font-weight: bold;
    color: #376bff;
    line-height: 30px;
    font-size: 20px;
    margin-bottom:15px;
  }
  .info span{
    font-weight: 500;
    color: #999999;
    // line-height: 42px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }
  .return-btn {
    margin-top: 1rem;
    .title {
      font-weight: 500;
      color: #ffffff;
      font-size: 20px;
    }
  }
}
.pager {
  background: #fff;
  .van-cell .van-cell__title {
    width: 30%;
    span{
      font-size: 15px;
    }
  }
  .fieldTitle{
     font-size: 15px !important;
  }
  .current-steps {
    display: flex;
    justify-content: space-evenly;
    padding: 1rem 0 0.5rem;
    .step {
      // background: red;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .itemBox {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .line {
      position: absolute;
      left: 50%;
      right: -50%;
      width:80px;
      height: 1px;
      background: #376bff;
    }
  }
  .tab-title {
    padding-top: 10px;
    // margin-left: -10px;
  }

  .tab-grid-item {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 0 3px;
    z-index: 99;
    &::after {
      width: 50px;
      height: 1px;
      background: #376bff;
    }
    .circle {
      text-align: center;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      &::after {
        content: "";
        padding-top: 100%;
      }
    }
    .tab-number {
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      background: #9f9f9f;
      border-radius: 100%;
      text-align: center;
      box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #d3d4e0f2;
    }
    .tab-title {
      font-weight: 500;
      padding-top: 10px;
      color: #9f9f9f;
    }
  }
  .isActive {
    .tab-number {
      background: #376bff;
    }
    .tab-title {
      color: #376bff;
      font-size: 14px;
    }
  }
}
.common-user {
  // background: #ffffff;

  .form {
    .container {
      margin-top: 0.2rem;
      border-top: #f6f6f6 solid 1em;
      .model-container {
        margin-bottom: 5px;
        padding-left: 0.5rem;
        padding-top: 0.5rem;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #376bff;
        .button-right {
          padding: 1em;
          font-size: 16px;
          .title {
          }
        }
      }
    }
  }

  .page-header-warming {
    margin: 0 0.5rem;
    color: #376bff;
    background: #ecf1ff;
    text-align: center;
    border-radius: 0.1rem;
    .content {
      font-family: PingFang SC;
      font-weight: 500;
      color: currentColor;
      line-height: 1rem;
    }
  }
  .button-control {
    padding: 0.5rem;
  }
  .form-container {
    margin-top: 0.5rem;

    .info-block {
      display: flex;
      justify-content: center;
      &::before {
        content: "";
        background: url("./imgs/bar.png") no-repeat;
        width: 1em;
        background-size: contain;
      }
      .info-block-title {
        font-size: 20px !important;
        font-weight: bold;
        color: #333333;
      }
    }

    .field {
      margin: 0 0.5rem;
      border-bottom: 0.01rem dashed #e8e5e5;
      .textarea {
        display: flex;
        flex-direction: column;
        font-size: larger;
        .required {
          font-weight: 500;
          color: #1f1f1f;
          margin: 1em 0 0 1em;

          font-size: 18px;
          &::before {
            content: "*";
            color: red;
          }
        }
        .van-field__control {
          border: 0.01rem solid #efefef;
          padding: 1em;
          font-size: 18px;
        }
      }
    }
    .field2{
      border-bottom:none;
    }
    .applyUser {
      background: #fff;
    }
    .respondentUser {
      background: #fff;
    }
    .disputeContent {
      background: #fff;
    }

    .form-organization {
      background: #f5f5f5 !important;
      .search-wrapper {
        display: flex;
        justify-content: space-around;
        font-size: large;
        background: #fff;
        border-radius: 999rem;
        flex-direction: row;
        text-align: center;
        padding: 0.5em;
        margin-top: 0.5em;
      }

      .model-container {
        background: none;
      }
    }
    .organization-Item {
      position: relative;
      padding: 1em;
      box-shadow: 0.1rem 0.1rem 0.1rem #c8c0c0;
      margin: 1em;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(233, 233, 233, 0.8);
      border-radius: 16px;

      .row {
        margin-top: 0.2rem;
        width: 100%;
      }
      .name {
        display: flex;
        .organization-name {
          width: 75%;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          -webkit-text-overflow: ellipsis;
          -moz-text-overflow: ellipsis;
          white-space: nowrap;
          font-size: medium;
        }
        .mediator-num {
          // position: absolute;
          // right: 0.1rem;
          // top: 0.1rem;
          padding: 0.1rem 0.3rem;
          color: #376bff;
          background: rgba(55, 107, 255, 0.1);
          border-radius: 24px;
          white-space: nowrap;
        }
      }
      .address {
        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
        -moz-text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0;
      }
    }
    .organization-Item-isChosen {
      color: #ffffff;
      background: linear-gradient(90deg, #3790ff, #376bff);
      box-shadow: 0px 20px 14px 0px rgba(102, 174, 228, 0.18);
      border-radius: 16px;
    }
    .mediator-num-isChosen {
      color: #ffffff !important;
      background: rgba(255, 255, 255, 0.3) !important;
    }
    .button-block {
      text-align: center;
      padding: 0.5rem;
      .add-Agent-button {
        background: #ecf1ff;
        color: #376bff;
        padding: 0.3rem 0.5rem;
        border: #ecf1ff;
        border-radius: 0.1rem;
        font-size: initial;
        font-weight: bold;
      }

      .Previous-button {
        background: #d7e5f6;
        border-radius: 5rem;
        padding: 0.5rem 1rem;
        color: #376bff;
      }
    }
  }
}
</style>
